import { msg, tr } from '../../../i18n/msg';

/**
 * Коды ошибок WS игр (GameHub / DurakHub `{t:'error', code, msg}`) → переводимый текст.
 * BAD_REQUEST / INTERNAL сюда не входят: у них конкретный `msg` (сервер переводит его на язык из ws-ticket).
 */
const GAME_ERRORS = {
  HOST_OFFLINE: msg('game_error.host_offline', 'Your friend is offline right now'),
  INSUFFICIENT_FUNDS: msg('game_error.insufficient_funds', 'Not enough GRAM for this stake'),
  REPLACED: msg('game_error.replaced', 'Opened in another window'),
  ROOM_EXPIRED: msg('game_error.room_expired', 'Your invite expired'),
  ROOM_FAILED: msg('game_error.room_failed', 'Could not start the game with your friend'),
  ROOM_NOT_FOUND: msg('game_error.room_not_found', 'This invite has expired or was cancelled'),
  ROOM_OWN: msg('game_error.room_own', 'This is your own invite'),
  DATUM_PASS_REQUIRED: msg('game_error.datum_pass_required', 'Playing for GRAM requires an active DatumPass'),
};

export const gameErrorText = (t, error) =>
  tr(t, GAME_ERRORS[error?.code]) || error?.msg || error?.code || t('common.error', 'Error');
